<template>
  <div id="mental-health-survey-welcome">
    <img src="@/assets/img/welcome-img@2x.png" alt="BetterMynd" />
    <h1>Welcome, {{ $store.getters.currentUser.displayName }}!</h1>
    <p>
        Thank you for registering on BetterMynd. Please take this quick 5-minute intake survey, which will allow us to help match you with the best counselors and resources for your specific needs.
    </p>
    <div class="row btn-row">
        <div class="col-12 col-md-6">
            <button
                class="btn btn-primary"
                type="button"
                @click="start"
            >
                Get Started
            </button>
        </div>
        <div class="col-12 col-md-6 text-right">
            <button
                type="button"
                class="btn btn-ghost"
                @click="skip"
            >
                Skip
            </button>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    methods: {
        skip() {
            this.$emit('skip')
        },
        start() {
            this.$emit('start')
        }
    }
}
</script>

<style lang="scss" scoped>
#mental-health-survey-welcome {
    width: 100%;

    img {
        width: 100%;
    }

    .btn {
        width: 100%;
        margin-bottom: 5px;
    }
}
</style>